import { render, staticRenderFns } from "./BasisCreditsPopup.vue?vue&type=template&id=517edb4a&scoped=true&"
import script from "./BasisCreditsPopup.vue?vue&type=script&lang=js&"
export * from "./BasisCreditsPopup.vue?vue&type=script&lang=js&"
import style0 from "./BasisCreditsPopup.vue?vue&type=style&index=0&id=517edb4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517edb4a",
  null
  
)

export default component.exports